import { UseQueryResult } from '@tanstack/react-query'
import {
  DrivePassengerGradeEventRes,
  getDrivePassengerGradeEvent,
} from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai/index'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  useErrorBoundary?: boolean
}

function useGetDrivePassengerGradeEvent(
  props: Props
): UseQueryResult<DrivePassengerGradeEventRes, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)
  return useQueryWrapper<DrivePassengerGradeEventRes, AxiosError>(
    KEYS.USER_MILEAGE_GRADE(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get<DrivePassengerGradeEventRes>(
          '/drive/external/user-api/v1/passenger/grade-event'
        )
        return data
      } else {
        const { data } = await getDrivePassengerGradeEvent()
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetDrivePassengerGradeEvent }
